/* eslint-disable react-native/no-inline-styles */
import React, { memo } from 'react';
import { Divider, Modal } from 'native-base';
import { DocUploadHeader, DocUploadFooter, DocUploadBody } from '../../../../components';
import { useLipStore } from '../../../reducers';
const DocUploadModal = ({}) => {
  const {
    taskName,
    isShowDocUploadModalWeb
  } = useLipStore(state => state);
  return isShowDocUploadModalWeb ? /*#__PURE__*/React.createElement(Modal.Content, {
    borderRadius: 4,
    padding: 8,
    width: {
      base: '75',
      sm: '75',
      md: '592',
      lg: '592'
    },
    maxHeight: 'auto'
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    style: {
      borderBottomWidth: 0,
      margin: 0,
      padding: 0,
      paddingBottom: 16
    }
  }, /*#__PURE__*/React.createElement(DocUploadHeader, {
    title: 'Upload ' + taskName
  })), /*#__PURE__*/React.createElement(Modal.Body, {
    margin: '0',
    padding: '0'
  }, /*#__PURE__*/React.createElement(DocUploadBody, {
    taskName: taskName
  }), /*#__PURE__*/React.createElement(Divider, {
    mt: 4,
    backgroundColor: 'lightBlue.200',
    height: '1px',
    mb: 4
  })), /*#__PURE__*/React.createElement(Modal.Footer, {
    borderTopWidth: '0',
    paddingTop: '2',
    paddingRight: '0',
    paddingBottom: '0'
  }, /*#__PURE__*/React.createElement(DocUploadFooter, {
    taskName: taskName
  }))) : null;
};
export default /*#__PURE__*/memo(DocUploadModal);
//# sourceMappingURL=index.js.map